export default {
	SECTION: 'section',
	TEMPLATE: 'template',
	TUTORIALS: 'tutorials',
	VIDEO: 'video',
	QUICK_TIP: 'quickTip'
};
